// extracted by mini-css-extract-plugin
module.exports = {"navbar":"AppBar_navbar__3Rt1d"};